"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createContext, useContext, useState } from "react";
// Create a Context for the company identifier
const CompanyContext = createContext<string | null>(null);

export function useCompanyIdentifier() {
  return useContext(CompanyContext);
}

export default function Providers({
  children,
  companyIdentifier,
}: {
  children: React.ReactNode;
  companyIdentifier: string;
}) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <CompanyContext.Provider value={companyIdentifier}>
        {children}
      </CompanyContext.Provider>
    </QueryClientProvider>
  );
}
